<template>
  <div>
    <b-modal
      no-close-on-backdrop
      v-model="modalShow"
      content-class="modal-finish"
      hide-footer
      ref="modal-modulo"
      hide-header-close
      centered
      size="md"
    >
      <b-row align-h="center" class="mt-4">
        <div id="timer" class="timer2">0h 0m 0s</div>
      </b-row>
      <b-row align-h="center" class="mt-4 examen-finish">
        <p>Su tiempo Termino</p>
      </b-row>
      <b-row align-h="center" class="mt-1 examen-finish2">
        <p>Lo sentimos el tiempo del modulo Termino</p>
      </b-row>

      <b-row align-h="center">
        <button @click="nextModulo()" class="modal-button-accept">Aceptar</button>
      </b-row>
    </b-modal>
    <b-row>
      <p class="timer-title mt-n5">Tiempo restaste del modulo</p>
    </b-row>
    <b-row>
      <div id="timer" class="timer">{{hours}}h {{minutes}}m {{seconds}}s</div>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "Simulacro",
  props: ["starttime", "endtime", "trans","accept"],
  data: () => ({
    modalShow: false,
    timer: "",
    wordString: {},
    start: "",
    end: "",
    interval: "",
    days: "",
    minutes: "",
    hours: "",
    seconds: "",
    message: "",
    statusType: "",
    statusText: ""
  }),
  created() {
    this.wordString = JSON.parse(this.trans);
  },
  mounted() {
    this.start = Date.now();
    this.end = new Date(this.endtime).getTime();
    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end);
    }, 1000);
  },
  methods: {
    nextModulo() {
      let last = localStorage.getItem("ultimo_modulo")
              console.log(last)
      if(last=='true'){
      this.accept()
      }else{
      var existing = JSON.parse(localStorage.getItem("respuestasAll"))
        ? JSON.parse(localStorage.getItem("respuestasAll"))
        : [];
      var res = JSON.parse(localStorage.getItem("respuestas"))
        ? JSON.parse(localStorage.getItem("respuestas"))
        : [];
      existing.push(res);
      localStorage.setItem("respuestasAll", JSON.stringify(existing));
      localStorage.removeItem("respuestas");
      localStorage.removeItem("limite");
      localStorage.removeItem("index");
      this.respuestas = [];
      let modulo = parseInt(localStorage.getItem("modulo"))
        ? parseInt(localStorage.getItem("modulo"))
        : 0;
      localStorage.setItem("modulo", modulo + 1);
      location.reload();
      }
    },
    timerCount: function(start, end) {
      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date
      var distance = start - now;
      var passTime = end - now;

      if (distance < 0 && passTime < 0) {
        this.message = this.wordString.expired;
        this.statusType = "expired";
        this.modalShow = true;
        //let modulo = parseInt(localStorage.getItem('modulo')) ? parseInt(localStorage.getItem('modulo')) : 0
        //localStorage.setItem('modulo', modulo+1)
        this.statusText = this.wordString.status.expired;
        clearInterval(this.interval);
        return;
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime);

        // this.message = this.wordString.running;
        this.statusType = "running";
        //this.statusText = this.wordString.status.running;
      } else if (distance > 0 && passTime > 0) {

        this.calcTime(distance);
        this.message = this.wordString.upcoming;
        this.statusType = "upcoming";
        this.statusText = this.wordString.status.upcoming;
      }
    },
    calcTime: function(dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    }
  }
};
</script>